
let WomenData = [
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11364258/2020/1/31/899b523a-f57a-48fb-80cd-8422614f195d1580451588210-SASSAFRAS-Women-Green--Beige-Printed-Blouson-Top-49515804515-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Floral Georgette Blouson Top",
      "product" : "Top",
      "price": "674",
      "MP": "1499",
      "offer": 55
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12222044/2020/8/14/16302e01-c0ca-4e70-80e5-db8c2064ce8f1597405258249-SASSAFRAS-Women-Peach-Coloured-Solid-Top-9011597405255592-1.jpg",
      "brand": "SASSAFRAS",
      "type": "High-Neck Top",
      "product" : "Top",
      "price": "499",
      "MP": "999",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9070021/2019/3/28/f0bce3b7-9ca8-45c9-a33d-dfd07c849a9c1553778513694-SASSAFRAS-Women-Beige--Black-Regular-Fit-Printed-Shirt-11915-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Animal Print Shirt Style Top",
      "product" : "Top",
      "price": "629",
      "MP": "1399",
      "offer": 55
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11679908/2020/5/25/8046704c-bff4-45bc-bf0f-5d438724b7b81590424372490CottinfabWomensBrownPleatedTrouserTopsCarltonLondonWomenTops1.jpg",
      "brand": "Carlton London",
      "type": "Victorian Crop Fitted Top",
      "product" : "Top",
      "price": "667",
      "MP": "1390",
      "offer": 52
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12284212/2020/8/25/8fc39488-cee7-4424-870d-ae5bd666d19c1598366814622-SASSAFRAS-Women-Black-Solid-Top-601598366813572-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Ribbed Crop Top",
      "product" : "Top",
      "price": "449",
      "MP": "899",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8643215/2019/2/1/dd3ef60d-be47-4a19-93c9-8598694020281549016416015-SASSAFRAS-Women-Grey-Solid-Blouson-Top-7381549016414303-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Layered Cropped Blouson Top",
      "product" : "Top",
      "price": "499",
      "MP": "999",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1052250/2019/4/11/fb86e884-dbdc-4951-bb45-38cc400c437f1554985706259-SASSAFRAS-Women-Olive-Green-Regular-Fit-Solid-Casual-Shirt-3-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Ruffled Shirt Style Top",
      "product" : "Top",
      "price": "549",
      "MP": "999",
      "offer": 45
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/1/27/c3f87e02-333b-4008-aa5c-3bb5d3fc658a1611743836816-1.jpg",
      "brand": "Harpa",
      "type": "Square Neck Top",
      "product" : "Top",
      "price": "643",
      "MP": "1399",
      "offer": 54
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/4325708/2018/4/2/11522662991296-Style-Quotient-Women-Tops-4231522662991112-1.jpg",
      "brand": "Style Quotient",
      "type": "Polka Dot Print Top",
      "product" : "Top",
      "price": "575",
      "MP": "1599",
      "offer": 64
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8841591/2019/3/5/e92e95ab-68ed-4c6b-8d3e-146d777f9bbf1551780857345-La-Zoire-Stripe-Shifly-Top-831551780856037-1.jpg",
      "brand": "La Zoire",
      "type": "Striped A-Line Top",
      "product" : "Top",
      "price": "879",
      "MP": "1599",
      "offer": 45
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13843266/2022/4/18/abaa6501-e1be-4b8e-af96-ecae86eed9e41650283574811SassafrasBlackSilverStripedOneShoulderPuffSleevesCinchedWais1.jpg",
      "brand": "SASSAFRAS",
      "type": "Striped One Shoulder Puff Sleeves Top",
      "product" : "Top",
      "price": "674",
      "MP": "1499",
      "offer": 55
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9070485/2022/4/18/c2030007-83c4-4a80-8a9e-c964cef044791650284882570SASSAFRASBlackStyledBackCropTop1.jpg",
      "brand": "SASSAFRAS",
      "type": "Styled Back Crop Top",
      "product" : "Top",
      "price": "499",
      "MP": "999",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13842966/2021/4/3/3d20dde9-8c47-48f2-a079-8cdacd9c78b11617444711671-Sassafras-Brown--Red-Geometric-Printed-Georgette-Wrap-Crop-T-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Geometric Printed Georgette Wrap Top",
      "product" : "Top",
      "price": "674",
      "MP": "1499",
      "offer": 55
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10308651/2019/7/26/09114b19-d977-46ca-8f25-f33c9b47456a1564140179144-SASSAFRAS-Women-Blue-Solid-Top-3621564140176982-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Pleated Frilled Hem Top",
      "product" : "Top",
      "price": "559",
      "MP": "1399",
      "offer": 60
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11364152/2020/1/27/091a681c-beb4-4192-bc64-44ca554391141580121893720-SASSAFRAS-Women-White-Solid-Blouson-Top-731580121889856-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Extended Sleeved Blouson",
      "product" : "Top",
      "price": "499",
      "MP": "999",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13647612/2021/3/2/ae01b413-6d60-4f2f-a851-24bf78ae0a801614675775880-Varanga-Pink-Floral-And-Bird-Printed-Crop-Top-With-Puff-Slee-1.jpg",
      "brand": "Varanga",
      "type": "Floral Printed Crop Top",
      "product" : "Top",
      "price": "597",
      "MP": "1299",
      "offer": 54
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13719118/2021/3/3/d7568371-96e2-4588-b0b2-fa7f3a2d6edb1614752823080-Athena-Turquoise-Blue-top-with-power-shoulder-sleeve-detail--1.jpg",
      "brand": "Athena",
      "type": "Power Shoulders Top",
      "product" : "Top",
      "price": "636",
      "MP": "1299",
      "offer": 51
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10856186/2019/11/30/c93932d4-79f1-4115-b07c-21bb59775a671575111475924-SASSAFRAS-Women-Tops-1431575111474030-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Solid Top",
      "product" : "Top",
      "price": "539",
      "MP": "1199",
      "offer": 55
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11679908/2020/5/25/8046704c-bff4-45bc-bf0f-5d438724b7b81590424372490CottinfabWomensBrownPleatedTrouserTopsCarltonLondonWomenTops1.jpg",
      "brand": "Carlton London",
      "type": "Victorian Crop Fitted Top",
      "product" : "Top",
      "price": "667",
      "MP": "1390",
      "offer": 52
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9553433/2022/4/20/88ea5805-292d-40c3-b53a-fbf4fa33c1481650446688676SASSAFRASGreenWhiteStripedStyledBackCropTop1.jpg",
      "brand": "SASSAFRAS",
      "type": "Styled Back Crop Top",
      "product" : "Top",
      "price": "449",
      "MP": "899",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12797568/2020/11/11/b5389152-fe8a-4729-ac94-e361353bfbad1605068283796-Cottinfab-Women-Tops-9111605068282525-1.jpg",
      "brand": "Cottinfab",
      "type": "Printed Shirt Style Pure Cotton Top",
      "product" : "Top",
      "price": "479",
      "MP": "1199",
      "offer": 60
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7256716/2018/8/31/75084dda-6d3f-4387-9b4a-b776dfae3a651535708100723-na-8491535708100420-1.jpg",
      "brand": "Mayra",
      "type": "Striped A-Line Top",
      "product" : "Top",
      "price": "417",
      "MP": "995",
      "offer": 58
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13719146/2021/3/3/d2d0ad98-7563-4d4d-af0a-a99abaeca74b1614753570173-Athena-Sea-Green-top-with-power-shoulder-sleeve-detail-12416-1.jpg",
      "brand": "Athena",
      "type": "Power Shoulders Top",
      "product" : "Top",
      "price": "636",
      "MP": "1299",
      "offer": 51
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13843006/2021/4/9/f03c740b-8aae-4505-89e5-2f2a5e76a3fe1617974298161-Sassafras-Blue-Pure-Cotton-Fitted-Crop-Top-6761617974297629-1.jpg",
      "brand": "SASSAFRAS",
      "type": "Fitted Crop Top",
      "product" : "Top",
      "price": "449",
      "MP": "899",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/12/1/34ed596f-7dd3-45e0-a7b9-20ddf041da9a1606815654154-1.jpg",
      "brand": "Tokyo Talkies",
      "product" : "Top",
      "type": "Solid Top",
      "price": "379",
      "MP": "949",
      "offer": 60
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9240703/2022/4/12/4dc1199d-d684-41d1-9035-5a6483e5e1a21649748075919herbyinvictusOliveGreenSmartCasualTop1.jpg",
      "brand": "her by invictus",
      "type": "Smart Casual Top",
      "product" : "Top",
      "price": "559",
      "MP": "1599",
      "offer": 65
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13738182/2021/7/5/ae19d5f2-c171-4cef-baf7-360007dcf72c1625487089028-VENI-VIDI-VICI-Fuschia--Frilled-Tie-Back-Top-687162548708858-1.jpg",
      "brand": "Veni Vidi Vici",
      "type": "Ruffled Crop Top",
      "product" : "Top",
      "price": "468",
      "MP": "1170",
      "offer": 60
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12221932/2020/10/6/fc845ff5-a434-48a4-8dca-9b4bf3fb52391601959631371-SASSAFRAS-Women-Black-High-Neck-Cropped-Top-4281601959630186-1.jpg",
      "brand": "SASSAFRAS",
      "type": "High Neck Cropped Top",
      "product" : "Top",
      "price": "399",
      "MP": "799",
      "offer": 50
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11711840/2020/10/13/c4034971-d71f-416c-9d48-82f1c39127c01602590834834MastHarbourWomenSeaGreenYellowFloralPrintedCropTop1.jpg",
      "brand": "Mast & Harbour",
      "type": "Floral Lace Crop Top",
      "product" : "Top",
      "price": "454",
      "MP": "1299",
      "offer": 65
    },
    {
      "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11144044/2020/2/6/d8b6c14b-af7f-439d-a260-383e0eb7a7bd1580965077361-Mast--Harbour-Women-Blue-Self-Striped-Top-3821580965076362-1.jpg",
      "brand": "Mast & Harbour",
      "type": "Self-Striped Pure Cotton Top",
      "product" : "Top",
      "price": "559",
      "MP": "1599",
      "offer": 65
    },
    // top end here
    // Lipstick Start here
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11178082/2020/1/13/22d48310-290a-429b-8534-db884cde683f1578907784720-Maybelline-New-York-Sensational-03-Flush-It-Red-Liquid-Matte-1.jpg",
        "brand": "Maybelline",
        "type": "Matte Lipstick-Flush It Red 03",
        "product" : "Lipstick & Kajal",
        "price": "268",
        "MP": "349",
        "offer": 23
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11178096/2022/3/28/16f525cb-5e71-4193-8f59-3a52b4925f501648457264774-Maybelline-New-York-Sensational-Liquid-Matte-Lipstick---08-S-1.jpg",
        "brand": "Maybelline",
        "type": "Liquid Matte Sensationally Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "289",
        "MP": "349",
        "offer": 17
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14336572/2021/5/24/0c23a790-a8e3-4a27-be5e-2b177698a2c61621829340252-Maybelline-Women-Beauty-Gift-Set-1431621829340019-1.jpg",
        "brand": "Maybelline",
        "type": "Set of 4 Lipstick Matte Minis",
        "product" : "Lipstick & Kajal",
        "price": "316",
        "MP": "396",
        "offer": 20
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2230635/2017/11/7/11510034492880-Maybelline-Women-Lipstick-9421510034492872-1.jpg",
        "brand": "Maybelline",
        "type": "Super Stay Matte - 15 Lover Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "650",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13105590/2022/4/13/fe16c1fd-2fd7-4281-9fac-211e1b3252271649824360798Lakme9to5PrimerMatteLipstick-PlumPickMP41.jpg",
        "brand": "Lakme",
        "type": "Matte Lipstick-Plum Pick MP4",
        "product" : "Lipstick & Kajal",
        "price": "400",
        "MP": "500",
        "offer": 20
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8051025/2022/2/21/61beefd1-6915-4944-bf1b-a7463e5f260f1645423276110-Maybelline-New-York-Super-Stay-Matte-Ink-Liquid-Lipstick---F-1.jpg",
        "brand": "Maybelline",
        "type": "Super Stay Matte - Founder 115 Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "594",
        "MP": "699",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6870092/2018/12/26/001c5c9d-ec8a-4091-a16b-df8a850b0bbe1545825125810-Maybelline-New-York-80-Ruler-Super-Stay-Matte-Ink-Liquid-Lip-1.jpg",
        "brand": "Maybelline",
        "type": "Super Stay Matte - Ruler 80 Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "608",
        "MP": "699",
        "offer": 13
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15990822/2021/12/8/fa878233-56ad-462c-aa4d-b0aa43583c151638957490027-Maybelline-Color-Sensational-Ultimattes-Lipstick-More-Blush--5.jpg",
        "brand": "Maybelline",
        "type": "Lipstick 499 More Blush Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "494",
        "MP": "549",
        "offer": 10
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2383022/2018/3/14/11521032706846-Maybelline-Color-Sensational-Chilli-Nude-Inti-Matte-Nudes-Lipstick-2141521032706813-1.jpg",
        "brand": "Maybelline",
        "type": "Matte Lipstick - Chilli Nude Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "209",
        "MP": "299",
        "offer": 30
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2019/12/20/91913af8-d794-4aa7-b4a1-b54176fbb3321576792969444-2.jpg",
        "brand": "SUGAR",
        "type": "Matte Transferproof Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "699",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11632896/2021/7/26/9d860722-88ac-4ec4-adb0-19eebbaeb0e41627289836416-SUGAR-Set-of-4-Smudge-Me-Not-Liquid-Mini-Nude-Lipstick-41416-1.jpg",
        "brand": "SUGAR",
        "type": "Set of 4 Mini Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "799",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/1/9/b0841404-fbd0-41bc-afcd-56eeacdec8e01610179137422-1.jpg",
        "brand": "Just Herbs",
        "type": "Ayurvedic Lipstick Trial Kit",
        "product" : "Lipstick & Kajal",
        "price": "460",
        "MP": "575",
        "offer": 20
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13105572/2021/1/25/9547adc2-db67-42b6-81d5-fbd835046a5d1611572248485-Lakme-Women-Lipstick-2481611572247698-1.jpg",
        "brand": "Lakme",
        "type": "Lipstick-Rosy Sunday MP8",
        "product" : "Lipstick & Kajal",
        "price": "470",
        "MP": "500",
        "offer": 6
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15990832/2021/12/1/39122196-78f1-4485-ae4d-fd6f6a57c84f1638338165721-Maybelline-Women-Lipstick-5591638338165630-1.jpg",
        "brand": "Maybelline",
        "type": "Lipstick- 399 More Magenta",
        "product" : "Lipstick & Kajal",
        "price": "466",
        "MP": "549",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1906679/2022/4/21/287444a2-5425-48b4-8f3f-9777d201a4251650544469288LakmeEnrichLipCrayonCinnamonBrown091.jpg",
        "brand": "Lakme",
        "type": "Enrich Lip Crayon - Cinnamon Lipstick Brown",
        "product" : "Lipstick & Kajal",
        "price": "258",
        "MP": "275",
        "offer": 6
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/55269/2021/3/24/2a8ba3df-cca2-4f48-ab17-8cd307538c621616563309201-Lakme-Absolute-Shine-Line-Eye-Liner---Black-3261616563308869-1.jpg",
        "brand": "Lakme",
        "type": "Shine Line Eye Liner - Black ",
        "product" : "Lipstick & Kajal",
        "price": "378",
        "MP": "450",
        "offer": 16
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1514918/2020/7/24/b1706334-cc5a-4330-b86f-c7b520e395e41595568842568LakmeAbsoluteShineLineEyeliner-ShimmeryBronze45ml1.jpg",
        "brand": "Lakme",
        "type": "Eyeliner - Shimmery Bronze ",
        "product" : "Lipstick & Kajal",
        "price": "441",
        "MP": "450",
        "offer": 2
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1514916/2020/7/24/f55c439b-c0c5-4608-8cf5-d2ede94043fe1595568838351LakmeAbsoluteShineLineEyeliner-SteelGrey45ml1.jpg",
        "brand": "Lakme",
        "type": "Line Eyeliner - Steel Grey",
        "product" : "Lipstick & Kajal",
        "price": "441",
        "MP": "450",
        "offer": 2
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1967184/2018/4/9/11523275170012-Maybelline-EYESTUDIO-Blackest-Black-Dramatic-Gel-Eyeliner-950-1301523275169972-1.jpg",
        "brand": "Maybelline",
        "type": "Gel Eyeliner - Blackest Black ",
        "product" : "Lipstick & Kajal",
        "price": "350",
        "MP": "500",
        "offer": 30
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1514917/2022/2/23/67f121d0-0250-48a8-80e9-f95a913f49541645615415239-Lakme-Absolute-Shine-Line-Eyeliner---Sparkling-Olive-6441645-1.jpg",
        "brand": "Lakme",
        "type": "Eyeliner - Sparkling Olive Lipstick",
        "product" : "Lipstick & Kajal",
        "price": "441",
        "MP": "450",
        "offer": 2
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5660739/2022/4/18/d346f98d-585b-480e-847c-64bfa8f004d11650284885776MaybellineNewYorkColossalKajal-SuperBlack1.jpg",
        "brand": "Maybelline",
        "type": "Colossal Kajal - Super Black",
        "product" : "Lipstick & Kajal",
        "price": "240",
        "MP": "300",
        "offer": 20
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8450977/2022/2/23/1db855f2-5677-4590-9eef-2ded0bce94311645615492693-Lakme-9to5-Pure-Rouge-Blusher---Coral-Punch-1741645615492210-1.jpg",
        "brand": "Lakme",
        "type": "9to5 Pure Rouge Blusher",
        "product" : "Lipstick & Kajal",
        "price": "500",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2368963/2020/7/24/bd290bdf-abb9-4739-992c-87591d0a36ec1595568846153LakmeEyeconicFineTipLinerPen-DeepBlack1ml1.jpg",
        "brand": "Lakme",
        "type": "Fine Tip Liner Pen-Deep Black",
        "product" : "Lipstick & Kajal",
        "price": "445",
        "MP": "500",
        "offer": 11
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/56167/2019/1/11/08984654-668c-4f50-828b-a7b7d2d3492e1547199758092-Colorbar-Precision-Waterproof-Eye-Liner-4461547199758032-1.jpg",
        "brand": "Colorbar",
        "type": "Waterproof Eyeliner - Black",
        "product" : "Beauty & Eyeline",
        "price": "339",
        "MP": "399",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2000582/2022/4/26/8cae6f02-a974-4209-946c-843c932ad11a1650957988536-Lakme-9-to-5-SPF-30-Complexion-Care-Cream--Honey-30-g-809165-1.jpg",
        "brand": "Lakme",
        "type": "Honey SPF 30 CC Cream - 30 g",
        "product" : "Beauty & Eyeline",
        "price": "360",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/image/style/properties/285218/Lakme-9-to-5-Black-Impact-Eyeliner_1_96bd14879dc3013d4aed0c7216d36419.jpg",
        "brand": "Lakme",
        "type": "9to5 Eyeliner - Black Impact",
        "product" : "Lipstick & Kajal",
        "price": "252",
        "MP": "300",
        "offer": 16
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5803205/2018/6/5/499a621e-d253-4c47-b5de-ec262a99b0561528191281546-Lakme-9-to-5-Naturale-Black-Gel-Kajal-3-g-7971528191281456-1.jpg",
        "brand": "Lakme",
        "type": "Naturale Black Gel Kajal",
        "product" : "Lipstick & Kajal",
        "price": "441",
        "MP": "475",
        "offer": 7
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8886405/2020/5/27/d5cd2eda-fe90-414a-9a61-cce19fb4c1e71590583803223FACESCANADAMagneteyesKajal-Black01035g1.jpg",
        "brand": "FACES CANADA",
        "type": "Magneteyes Kajal Black 01",
        "product" : "Lipstick & Kajal",
        "price": "139",
        "MP": "179",
        "offer": 22
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2966311/2022/3/31/c85baf75-a526-47f1-bd27-c2a54e24b0581648724132330MaybellineNewYorkFaceStudioMasterChromeMetallicHighlighter-M1.jpg",
        "brand": "Maybelline",
        "type": "Studio Metallic Highlighter",
        "product" : "Lipstick & Kajal",
        "price": "449",
        "MP": "599",
        "offer": 25
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1546432/2022/4/1/3b25eb26-7876-4ca1-ba02-e6f93950777f1648804871850MaybellineNewYorkFitMeConcealer-10Light68ml1.jpg",
        "brand": "Maybelline",
        "type": "Fit Me Concealer - Light 10",
        "product" : "Lipstick & Kajal",
        "price": "399",
        "MP": "499",
        "offer": 20
      },
      // lipstick ends here
      // beauty products
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11629082/2022/5/4/e6bfd58f-f4f4-45ca-911d-e84d5eebfaef1651646980985-Lakme-Insta-Liner---Black-9ml-3461651646980759-1.jpg",
        "brand": "Lakme",
        "type": "Insta-Liner - Black 9ml",
        "product" : "Beauty & Eyeliner ",
        "price": "109",
        "MP": "130",
        "offer": 16
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11629094/2020/7/9/d9cc4f27-9deb-46ca-821e-a37410cbcbd51594288324999LakmeSetof2EyeconicKajal-DeepBlack070g1.jpg",
        "brand": "Lakme",
        "type": "Set of 2 Eyeconic Kajal",
        "product" : "Lipstick & Kajal",
        "price": "291",
        "MP": "320",
        "offer": 9
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1963241/2022/4/18/d937014a-3250-4803-a3ce-320a6de213e61650281596290-Maybelline-New-York-Colossal-Kajal---Black-4661650281595507-1.jpg",
        "brand": "Maybelline",
        "type": "Colossal Kajal - Black",
        "product" : "Lipstick & Kajal",
        "price": "162",
        "MP": "180",
        "offer": 10
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1514916/2020/7/24/f55c439b-c0c5-4608-8cf5-d2ede94043fe1595568838351LakmeAbsoluteShineLineEyeliner-SteelGrey45ml1.jpg",
        "brand": "Lakme",
        "type": "Line Eyeliner - Steel Grey",
        "product" : "Beauty & Eyeliner",
        "price": "441",
        "MP": "450",
        "offer": 2
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8886405/2020/5/27/d5cd2eda-fe90-414a-9a61-cce19fb4c1e71590583803223FACESCANADAMagneteyesKajal-Black01035g1.jpg",
        "brand": "FACES CANADA",
        "type": "Magneteyes Kajal Black 01",
        "product" : "Lipstick & Kajal",
        "price": "139",
        "MP": "179",
        "offer": 22
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11178488/2022/4/18/80cb29dd-2f09-4e80-9e7e-33f8818588d31650283565026MaybellineNewYorkLineTattooHighImpactLiner-IntenseBlack1.jpg",
        "brand": "Maybelline",
        "type": "Line Tattoo High Impact Liner",
        "product" : "Beauty & Eyeliner",
        "price": "467",
        "MP": "550",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14329750/2021/7/22/6cc9100c-59ad-4893-b3ab-101eb656a7711626955100865SUGARKohlOfHonourIntenseKajal-01BlackOutSingleBlister025gm1.jpg",
        "brand": "SUGAR",
        "type": "Intense Kajal - 01 Black Out",
        "product" : "Lipstick & Kajal",
        "price": "249",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1514917/2022/2/23/67f121d0-0250-48a8-80e9-f95a913f49541645615415239-Lakme-Absolute-Shine-Line-Eyeliner---Sparkling-Olive-6441645-1.jpg",
        "brand": "Lakme",
        "type": "Eyeliner - Sparkling Olive",
        "product" : "Beauty & Eyeliner",
        "price": "441",
        "MP": "450",
        "offer": 2
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1514918/2020/7/24/b1706334-cc5a-4330-b86f-c7b520e395e41595568842568LakmeAbsoluteShineLineEyeliner-ShimmeryBronze45ml1.jpg",
        "brand": "Lakme",
        "type": "Eyeliner - Shimmery Bronze",
        "product" : "Beauty & Eyeliner",
        "price": "441",
        "MP": "450",
        "offer": 2
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11884842/2021/2/15/5f29cede-eefb-4435-8d2a-62d3f6b756fb1613372681539-SUGAR-Eye-Told-You-So-Smudgeproof-Eyeliner-17-ml-18316133726-1.jpg",
        "brand": "SUGAR",
        "type": "Smudgeproof Eyeliner",
        "product" : "Beauty & Eyeliner",
        "price": "699",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8886477/2021/8/6/25c98cd3-a7f9-4634-915f-ef19b71021091628249311123-FACES-CANADA-Magneteyes-Eyeliner---Black-01-35-ml-4871628249-1.jpg",
        "brand": "FACES CANADA",
        "type": "Magnet Eyes Eyeliner- Black 01",
        "product" : "Beauty & Eyeliner",
        "price": "194",
        "MP": "249",
        "offer": 22
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/56167/2019/1/11/08984654-668c-4f50-828b-a7b7d2d3492e1547199758092-Colorbar-Precision-Waterproof-Eye-Liner-4461547199758032-1.jpg",
        "brand": "Colorbar",
        "type": "Waterproof Eyeliner - Black",
        "product" : "Beauty & Eyeliner",
        "price": "339",
        "MP": "399",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12274332/2021/3/24/7d81e6f4-bb89-41b5-8dcd-6b425f6d29831616574346145-Wet-n-Wild-Color-Icon-Kohl-Liner-Pencil---Youre-Always-White-1.jpg",
        "brand": "Wet n Wild",
        "type": "You're Always White E608A",
        "product" : "Beauty & Eyeliner",
        "price": "120",
        "MP": "195",
        "offer": 38
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5803205/2018/6/5/499a621e-d253-4c47-b5de-ec262a99b0561528191281546-Lakme-9-to-5-Naturale-Black-Gel-Kajal-3-g-7971528191281456-1.jpg",
        "brand": "Lakme",
        "type": "Naturale Black Gel Kajal",
        "product" : "Lipstick & Kajal",
        "price": "441",
        "MP": "475",
        "offer": 7
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/17024160/2022/3/16/d6893613-6c03-4b31-b976-ae7135d85f691647428824164PrettyWomenWomenSmudgeproofRetractableKohlGreenKajal0542gm1.jpg",
        "brand": "Pretty Women",
        "type": "Women Smudgeproof Retractable Kohl Green Kajal 05 4.2 gm",
        "product" : "Lipstick & Kajal",
        "price": "224",
        "MP": "249",
        "offer": 10
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14058032/2021/6/3/119f250c-3413-4c1d-a421-eb0ef6aff4ab1622720457832-Revlon-Set-of-4-Colour-Shine-Super-Lustrous-Nail-Enamels-517-1.jpg",
        "brand": "Revlon",
        "type": "4 Pcs Lustrous Nail Enamels",
        "product" : "Lipstick & Kajal",
        "price": "450",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/62474/2022/3/21/e3c77daa-76fe-4623-b0f6-e3d4d99cb2721647845969213-Maybelline-Lip-Smooth-Color-Changing-Peach-Bloom-Lip-Balm-17-1.jpg",
        "brand": "Maybelline",
        "type": "Peach Bloom Lip Balm 1.7g",
        "product" : "Beauty & Eyeliner",
        "price": "135",
        "MP": "180",
        "offer": 25
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14172246/2022/4/29/50d3b62a-21d7-4f54-a61f-77797b34ebf51651215613044-Garnier-Bright-Complete-VITAMIN-C-Booster-Face-Serum-30ml-31-1.jpg",
        "brand": "Garnier",
        "type": "VITAMIN C Bright Face Serum",
        "product" : "Beauty & Eyeliner",
        "price": "549",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12678954/2020/10/9/b82a6915-8d35-4510-93e8-249c2b115e541602216132908-Biotique-Advanced-Organics-Apple-Cider-Vinegar-Deep-Cleansin-1.jpg",
        "brand": "Biotique",
        "type": "Women Apple Cider Face Wash",
        "product" : "Beauty & Eyeliner",
        "price": "171",
        "MP": "225",
        "offer": 24
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/55163/2021/3/24/c96c707f-99b0-4952-9c3f-ed06b81bc8861616563219147-Lakme-True-Wear-Classics-Twilight-Mauve-Nail-Polish-103-3181-1.jpg",
        "brand": "Lakme",
        "type": "Nail Polish",
        "product" : "Beauty & Eyeliner",
        "price": "120",
        "MP": "125",
        "offer": 4
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10444666/2019/12/16/6aa1e3ee-588b-419b-ab41-8c8957cdef731576496070922-Olay-SPF-15-Total-Effects-7-In-1-Anti-Aging-Skin-Cream-50-g--1.jpg",
        "brand": "Olay",
        "type": "Anti Aging Cream 50 g",
        "product" : "Beauty & Eyeliner",
        "price": "674",
        "MP": "899",
        "offer": 25
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6837535/2022/3/9/0860bcb0-6525-4ac3-96be-a6b5cee3b9cf1646825666381TRESemmeKeratinSmoothShampoo580ml1.jpg",
        "brand": "TRESemme",
        "type": "Keratin Smooth Shampoo",
        "product" : "Beauty & Eyeliner",
        "price": "525",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10849078/2022/3/21/9c4a05b4-1ad9-4cec-b243-64e6f5364df11647837063216-Maybelline-Lip-Smooth-Color-Changing-Lip-Balm---Pink-Bloom-1-1.jpg",
        "brand": "Maybelline",
        "type": "Lip Balm - Pink Bloom 1.7g",
        "product" : "Beauty & Eyeliner",
        "price": "126",
        "MP": "180",
        "offer": 30
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6528962/2018/9/21/d4375779-3782-48d6-bb11-0f286360f0591537509696186-Maybelline-Women-Lip-Care-6861537509696033-1.jpg",
        "brand": "Maybelline",
        "type": "Broadway Red Baby Lips 4g",
        "product" : "Beauty & Eyeliner",
        "price": "159",
        "MP": "175",
        "offer": 9
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11699568/2022/1/27/d711eb0a-c9bd-473f-8367-9b99c64785a41643279982185BiotiqueWomenMorningNectarFlawlessSkinCreamwithBadamSeedOil11.jpg",
        "brand": "Biotique",
        "type": "Nectar Flawless Skin Cream",
        "product" : "Beauty & Eyeliner",
        "price": "174",
        "MP": "230",
        "offer": 24
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5711012/2022/4/18/26b2be49-b623-45eb-9bf0-74d62897db7e1650265034818-LOreal-Paris-Total-Repair-5-Shampoo-1925ml---1925-ml-5181650-1.jpg",
        "brand": "LOreal",
        "type": "Total Repair 5 Shampoo'",
        "product" : "Beauty & Eyeliner",
        "price": "122",
        "MP": "135",
        "offer": 9
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/18/ee9cbe99-9a9e-49f8-b603-da69d9cc6c371621319188346-1.jpg",
        "brand": "Plum",
        "type": "Rose Water Toner 100 ml",
        "product" : "Beauty & Eyeliner",
        "price": "180",
        "MP": "225",
        "offer": 20
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7196201/2018/9/28/061ebc76-c25a-464a-a6be-3241179332101538122410789-Maybelline-Women-Lipstick-1281538122410487-1.jpg",
        "brand": "Maybelline",
        "type": "Creamy Matte Lipstick 630",
        "product" : "Lipstick & Kajal",
        "price": "209",
        "MP": "299",
        "offer": 30
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/4384871/2021/8/11/44f62cd5-555e-45d2-ba86-05aad086ce001628671666203LakmeAbsolutePerfectRadianceSkinLighteningDayCreme15g1.jpg",
        "brand": "Lakme",
        "type": "Skin Lightening Day Creme 15g",
        "product" : "Beauty & Eyeliner",
        "price": "89",
        "MP": "99",
        "offer": 10
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11038230/2022/2/21/9bbd553c-d41e-4c23-b47e-07aaefee391b1645444471767-Livon-Set-of-2-Anti-Frizz-Hair-Serum-with-Vitamin-E--Argan-O-1.jpg",
        "brand": "Livon",
        "type": "Set of 2 Anti-Frizz Hair Serum",
        "product" : "Beauty & Eyeliner",
        "price": "415",
        "MP": "500",
        "offer": 17
      },
      // beauty ends here

      // Top again
      
      // top again ends here
      // KurtaSuits starts here
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13962098/2021/4/14/877b6542-dc0b-4352-bf9a-2e200ba068181618405391945DeewaPrintedPinkA-LineDressKurtaSetsZIYAAWomenKurtaSetsZIYAA6.jpg",
        "brand": "ZIYAA",
        "type": "Printed Kurta with Trousers",
        "product" : "Kurta & Palazzos",
        "price": "972",
        "MP": "2430",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14038092/2021/4/20/e70ba29d-ea27-4e0c-990e-38b4838f8e531618917104638KurtaSetsAHIKAWomenKurtaSetsAHIKAWomenKurtaSetsAHIKAWomenKur1.jpg",
        "brand": "AHIKA",
        "type": "Printed Kurta with Trousers & Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "1574",
        "MP": "3748",
        "offer": 58
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/6/2/0f576a65-3225-4aac-9db9-4b5743f9199f1622617345842-1.jpg",
        "brand": "Stylum",
        "type": "Women Striped Kurta with Trousers With Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "1056",
        "MP": "2400",
        "offer": 56
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/6/22/9faa9d87-fb5c-49e0-a748-d3511aa35cd11624340534242-1.jpg",
        "brand": "Indo Era",
        "type": "Women Yoke Design Kurta with Palazzos With Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "1759",
        "MP": "3999",
        "offer": 56
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16295538/2021/11/29/0e6f9fdd-2558-4c03-ab84-df9fbff2d5e91638190875095WomensPinkCottonPrintedKurtaWithTrouserSet1.jpg",
        "brand": "THE NKS PLUS",
        "type": "Woman Peach Kurta & Palazzos",
        "product" : "Kurta & Palazzos",
        "price": "899",
        "MP": "2499",
        "offer": 64
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14203104/2021/6/28/cb46c83c-9d85-4441-bbcb-aa21455b8a861624859278600-Sangria-Women-Kurta-Sets-9871624859277961-1.jpg",
        "brand": "Sangria",
        "type": "Women Cotton Kurta Sets",
        "product" : "Kurta & Palazzos",
        "price": "599",
        "MP": "1999",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/4/9/e9cc12aa-854b-48e0-b7ba-6bcf4e4a62e51617948770143-1.jpg",
        "brand": "ANAISA",
        "type": "Embroidered Kurta with Trousers",
        "product" : "Kurta & Palazzos",
        "price": "987",
        "MP": "2669",
        "offer": 63
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16991432/2022/1/31/d98622c6-c0e9-48d0-8af5-5c6ea78491d61643620795853GoSrikiWomenGreenStraightSolidKurtawithPalazzoDupatta1.jpg",
        "brand": "GoSriKi",
        "type": "Kurta with Trousers & Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "998",
        "MP": "3699",
        "offer": 73
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15262564/2021/10/18/3e5de65a-4aeb-4746-b981-4e3edfcd5fa01634543478338-Indo-Era-Women-Navy-Blue-Ethnic-Motifs-Yoke-Design-Cotton-Ku-13.jpg",
        "brand": "Indo Era",
        "type": "Women Yoke Design Kurta with Palazzos With Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "1403",
        "MP": "3599",
        "offer": 61
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16595430/2022/1/17/e71ccafc-0971-43fc-b6d2-259e9804c34d1642421396636RangritiWomenAssortedPrintedKurtawithPalazzosDupatta1.jpg",
        "brand": "Rangriti",
        "type": "Women Assorted Kurta Set",
        "product" : "Kurta & Palazzos",
        "price": "2299",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10306657/2019/9/21/185212e8-b3d5-4fee-886d-2aac0dd9e5211569064558443-IMARA-Women-Kurta-Sets-5061569064556675-1.jpg",
        "brand": "IMARA",
        "type": "Women Yoke Design Kurta with Trousers & Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "1499",
        "MP": "2999",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14345986/2022/2/4/2d941a96-a140-4707-8cee-bc3b2c26744b1643937538871NayoWomenNavyBlueStraightScreenPrintPureCottonKurtaPalazzosW1.jpg",
        "brand": "Nayo",
        "type": "Women Kurta Set & Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "1399",
        "MP": "3499",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/17171690/2022/2/16/c687fae9-54a6-4c01-af44-771d17fbe6211645005298812KALINIAngrakhaKurtaPantandDupattaSet3.jpg",
        "brand": "KALINI",
        "type": "Kurta with Trousers & Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "999",
        "MP": "3999",
        "offer": 75
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12307502/2022/4/18/ee3d06ff-fe83-4a7f-829a-2c1622987a371650283480461PrakhyaWomenPinkSelfDesignKurtawithTrousersDupatta1.jpg",
        "brand": "Prakhya",
        "type": "Self Design Kurta with Trousers & Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "989",
        "MP": "3298",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15508976/2021/9/29/6af853e2-4cf8-45e0-b28a-90c0ba578d0a1632905310824IndoEraBluePrintedStraightKurtaTrouserWithDupattaSet1.jpg",
        "brand": "Indo Era",
        "type": "Women Printed Kurta with Palazzos With Dupatta",
        "product" : "Kurta & Palazzos",
        "price": "2039",
        "MP": "5999",
        "offer": 66
      },
        // kurtsStuits ends here
        // HairStraightner
        {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9375005/2019/5/8/bf565462-b571-4c65-9e0e-ecaafc8b6d801557312258867-Philips-Women-Hair-Appliance-3831557312258283-1.jpg",
            "brand": "Philips",
            "type": "HP8120/00 Hair Dryer",
            "product" : "HairStraightner",
            "price": "1102",
            "MP": "1345",
            "offer": 18
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2019/11/30/cfda1d1b-7054-455b-be9f-56ba149d67731575065114849-1.jpg",
            "brand": "Ikonic",
            "type": "Women DIVA Hair Straightener",
            "product" : "HairStraightner",
            "price": "4200",
            "MP": 6000,
            "offer": 25
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9375035/2022/4/12/4e673a43-c609-4d58-96d1-b57d78628f9d1649748061359PhilipsHP864346MissFreshersStraightenerHairdryerStylingKit1.jpg",
            "brand": "Philips",
            "type": "HP8643/46 Straightener & Dryer",
            "product" : "HairStraightner",
            "price": "1858",
            "MP": "2295",
            "offer": 19
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12800108/2021/8/31/79a232dc-b05d-4d92-b1fc-68ff2eadfc861630404010381-Vega-Women-Keratin-3-in-1-Hair-Styler-VHSCC-03-4261630404009-1.jpg",
            "brand": "VEGA",
            "type": "Women Keratin 3 in 1 Styler",
            "product" : "HairStraightner",
            "price": "1715",
            "MP": "2199",
            "offer": 22
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13507848/2021/2/15/c082731b-f64b-4878-8628-a4f4c6502da81613394624242-Philips-Women-Hair-Appliance-8201613394621991-1.jpg",
            "brand": "Philips",
            "type": "Thermo Protect Hair Dryer",
            "product" : "HairStraightner",
            "price": "1996",
            "MP": "2495",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5589986/2020/11/17/9dc798fa-d74e-4f8e-bf2b-66da3881861f1605624172359-Ikonic-ProTitanium-Black-Shine-Hair-Straightner-816160562417-1.jpg",
            "brand": "Ikonic",
            "type": "Hair Straightener",
            "product" : "HairStraightner",
            "price": "7000",
            "MP": 9000,
            "offer": 25,
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9374997/2021/7/30/2613e26e-1c13-4054-8ad5-1841e8436a6b1627637166814-Philips-HP810046-SalonDry-ThermoProtect-1000W-Compact-Hair-D-1.jpg",
            "brand": "Philips",
            "type": "HP8100/46 SalonDry Hair Dryer",
            "product" : "HairStraightner",
            "price": "761",
            "MP": "875",
            "offer": 13
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2019/9/21/02db46a6-130c-4932-b923-54d0b7cebb781569054832778-1.jpg",
            "brand": "Ikonic",
            "type": "Mini Iron Hair Straightener",
            "product" : "HairStraightner",
            "price": "1575",
            "MP": 2000,
            "offer": 22,
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/4609758/2020/11/17/b19c4281-a912-46d7-adae-50df222020161605624131789-Ikonic-Glam-All-In-1-Black-Hair-Straightner-8111605624130331-1.jpg",
            "brand": "Ikonic",
            "type": "Hair Straightener",
            "product" : "HairStraightner",
            "price": "3500",
            "MP": 5000,
            "offer": 30
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12445350/2020/11/23/b538625c-34f4-4ece-92a7-64212506733f1606148686922-Philips-Women-Hair-Appliance-1361606148686636-1.jpg",
            "brand": "Philips",
            "type": "Ionic Styling Brush HP4722/20",
            "product" : "HairStraightner",
            "price": "1621",
            "MP": "2495",
            "offer": 35
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15285148/2022/2/17/a16d60fa-ca81-4936-a723-5f0054cd3d981645105127888SYSKASuperglamHS1050HairStraightener-Pink1.jpg",
            "brand": "SYSKA",
            "type": "HS1050 Hair Straightener",
            "product" : "HairStraightner",
            "price": "2399",
            "MP": 3000,
            "offer": 21
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5910805/2021/11/18/e52f1553-ee81-4d4d-9a1b-c59247a8ae0a1637187853482-VEGA-VHSS-03-Miss-Versatile-Hair-Styling-Set---Color-May-Var-15.jpg",
            "brand": "VEGA",
            "type": "VHSS-03 Hair Styling Set",
            "product" : "HairStraightner",
            "price": "2463",
            "MP": "3199",
            "offer": 23
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15285146/2022/2/17/91ec9287-a782-4ebe-b685-8bad0bb13a451645105129878SYSKASuperglamHS1050HairStraightener-Black1.jpg",
            "brand": "SYSKA",
            "type": "HS1050 Hair Straightener",
            "product" : "HairStraightner",
            "price": "2399",
            "MP": 4000,
            "offer": 45
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13525942/2021/7/18/d28421e0-1bb5-4173-b003-ca0c06ef235b1626591259654-Groomiist-Gold-Series-Multi-Functional-3-in-1-Hair-Straighte-1.jpg",
            "brand": "Groomiist",
            "type": "3 in 1 Hair Straightener",
            "product" : "HairStraightner",
            "price": "1418",
            "MP": "2446",
            "offer": 42
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12107582/2022/1/4/36c018c7-84cb-4f54-bc0f-43d60888ed2b1641292301018-Dyson-Airwrap-Complete-Hair-Styler---Red--Gunmetal-Toned-386-1.jpg",
            "brand": "dyson",
            "type": "Airwrap Complete Hair Styler",
            "product" : "HairStraightner",
            "price": "44900",
            "MP": 50000,
            "offer": 15
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10849124/2022/4/19/06ab8810-6393-4bd9-bd0a-100a2336a8b61650366021829MaybellineNewYorkTheNudesEyeshadowPalette-Blush9g1.jpg",
            "brand": "Maybelline",
            "type": "Eyeshadow Palette - Blush",
            "product" : "HairStraightner",
            "price": "769",
            "MP": "905",
            "offer": 15
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14240272/2021/10/27/b81763f1-882b-4456-8daf-3ea9ad5a65351635328781676PlumCandyMeltsVeganLipBalm-RedVelvetLove-12g1.jpg",
            "brand": "Plum",
            "type": "Lip Balm - Red Velvet Love",
            "product" : "HairStraightner",
            "price": "250",
            "MP": "295",
            "offer": 15
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12838504/2020/11/6/969cf5be-f93e-4a7f-9530-35052ff0d0601604661793589-Makeup-Revolution-London-Women-Makeup-Kit-2541604661793399-1.jpg",
            "brand": "Makeup Revolution London",
            "type": "Set of Eyeshadow & Highlighter",
            "product" : "HairStraightner",
            "price": "1200",
            "MP": "2400",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2174520/2021/7/27/157153cf-f7a9-4b1f-be3f-a4a4e99143451627402418673-SUGAR-Arrested-For-Overstay-Water-Proof-I-Will-Be-Black-Eyel-4.jpg",
            "brand": "SUGAR",
            "type": "I Will Be Black Eyeliner 01",
            "product" : "HairStraightner",
            "price": "899",
            "MP": 1000,
            "offer": 10
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13748724/2021/3/1/ec213bae-9f25-482a-8f6e-aafaa63950b21614600616670-Makeup-Revolution-London-Women-Eyeshadow-2581614600616483-1.jpg",
            "brand": "Makeup Revolution London",
            "type": "Set of 2 Reloaded Eyeshadows",
            "product" : "HairStraightner",
            "price": "840",
            "MP": "2100",
            "offer": 60
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16674826/2022/1/4/709c861b-be7b-4060-95ab-3c5fa4d9245a1641284103230AllureBlendingBrush-SGK-228s1.jpg",
            "brand": "ALLURE",
            "type": "Blending Makeup Eye Brush",
            "product" : "Beauty & Eyeliner",
            "price": "278",
            "MP": "299",
            "offer": 7
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10235945/2022/1/27/4dbe4a3b-9195-4b9f-ad5c-a7640e3fef9a1643279843160PondsSuperLightGelOilFreeMoisturiserwithHyaluronicAcidVitami1.jpg",
            "brand": "Ponds",
            "type": "Light Gel Oil Free Moisturiser",
            "product" : "Beauty & Eyeliner",
            "price": "309",
            "MP": 410,
            "offer": 30
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15605464/2021/9/26/bfa862ed-b626-4c44-9fdd-eeda2b0c02b21632616438753ColorbarKosherJadeFacialRoller1.jpg",
            "brand": "Colorbar",
            "type": "Kosher Jade Facial Roller",
            "product" : "HairStraightner",
            "price": "1312",
            "MP": "1750",
            "offer": 25
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/18/ee9cbe99-9a9e-49f8-b603-da69d9cc6c371621319188346-1.jpg",
            "brand": "Plum",
            "type": "Rose Water Toner 100 ml",
            "product" : "Beauty & Eyeliner",
            "price": "180",
            "MP": "225",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/4/12/66f9c4fb-2571-4c0a-ae3f-44bd270afc1d1618208092879-1.jpg",
            "brand": "MISS ROSE",
            "type": "Set Of 6 Matte Liquid Lipgloss",
            "product" : "Beauty & Eyeliner",
            "price": "1299",
            "MP": "3299",
            "offer": 2000
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14172246/2022/4/29/50d3b62a-21d7-4f54-a61f-77797b34ebf51651215613044-Garnier-Bright-Complete-VITAMIN-C-Booster-Face-Serum-30ml-31-1.jpg",
            "brand": "Garnier",
            "type": "VITAMIN C Bright Face Serum",
            "product" : "Beauty & Eyeliner",
            "price": "549",
            "MP": 600,
            "offer": 9
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14254354/2022/3/22/40e8fae2-e8f7-49ae-9723-39bf6763c0541647947204182-FACES-CANADA-Ultime-Pro-Sun-Defense-CC-Cream-Luxe-SPF-50-Ivo-1.jpg",
            "brand": "FACES CANADA",
            "type": "Luxe SPF 50 Ivory 01",
            "product" : "Beauty & Eyeliner",
            "price": "799",
            "MP": "999",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2421530/2022/4/25/3813980e-3d5e-4de0-9878-2ad3d9b567091650869407873FACESCANADAUltimeProMakeupFixer1.jpg",
            "brand": "FACES CANADA",
            "type": "Ultime Pro Makeup Fixer",
            "product" : "Beauty & Eyeliner",
            "price": "506",
            "MP": "649",
            "offer": 22
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15352458/2022/4/3/ccb1089d-aa8c-41bb-bc92-5c101e4f67211648967341839SKINKRAFTCustomizedSevereAcneKit1.jpg",
            "brand": "SKINKRAFT",
            "type": "Customized Severe Acne Kit",
            "product" : "Beauty & Eyeliner",
            "price": "1348",
            "MP": "2697",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/4425793/2020/10/10/55d1289f-174d-4ab3-90bc-524113ca10731602269397669WetnWildBlushBrushEC796White1.jpg",
            "brand": "Wet n Wild",
            "type": "Blush Brush EC796",
            "product" : "Beauty & Eyeliner",
            "price": "263",
            "MP": "425",
            "offer": 38
          },
          // hair straightner ends here
          // Flat(slipper ) start here
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10332219/2019/8/30/faba247e-5f1b-4694-801e-b18129c33ddd1567172536837-Taavi-Women-Rust-Coloured-Printed-Mules-151567172535985-1.jpg",
            "brand": "Taavi",
            "type": "Women Ikat Mules",
            "product" : "Flat",
            "price": "854",
            "MP": "1899",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15682024/2021/11/25/ce6f33c8-26e3-4fe9-868e-4c91351a9be41637830952702-Shoetopia-Women-Peach-Coloured-Printed-Ballerinas-Flats-8816-7.jpg",
            "brand": "Shoetopia",
            "type": "Women Ballerinas Flats",
            "product" : "Flat",
            "price": "599",
            "MP": "999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12384416/2020/9/1/12106de8-7db9-4bb0-8611-b8055c1184451598963814316ShoetopiaWomenPinkSolidBallerinas1.jpg",
            "brand": "Shoetopia",
            "type": "Women Ballerinas",
            "product" : "Flat",
            "price": "599",
            "MP": "999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11365474/2020/2/11/79b4d4bb-67ca-40fb-a7a6-cfbdf6d7c7321581423071776-Marc-Loire-Women-Grey--Pink-Woven-Design-Ballerinas-59915814-1.jpg",
            "brand": "Marc Loire",
            "type": "Women Woven Design Ballerinas",
            "product" : "Flat",
            "price": "999",
            "MP": "1998",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14713152/2021/9/22/945e8ab3-159d-47fc-8efd-a994b9ec80131632302629066-Shoetopia-Women-White-Open-Toe-Flats-with-Bows-1281632302628-7.jpg",
            "brand": "Shoetopia",
            "type": "Women Open Toe Flats",
            "product" : "Flat",
            "price": "599",
            "MP": "999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12721074/2021/2/17/fbaa44e5-fecd-420a-aa94-c41c88091f401613544338528-Shezone-Women-White-Printed-Ballerinas-7951613544337037-1.jpg",
            "brand": "Shezone",
            "type": "Women Ballerinas",
            "product" : "Flat",
            "price": "699",
            "MP": "999",
            "offer": 30
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/2/21/b4e6a311-2d00-4aa7-9d37-8476a54edd8f1582236941065-1.jpg",
            "brand": "ZAPATOZ",
            "type": "Women Open Toe Flats",
            "product" : "Flat",
            "price": "599",
            "MP": "999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9269831/2019/5/22/8c440396-597b-4f6b-ac76-60a2784f33fb1558510414742-DressBerry-Women-Flats-221558510413292-1.jpg",
            "brand": "DressBerry",
            "type": "Women Striped Flats",
            "product" : "Flat",
            "price": "854",
            "MP": "1899",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1424833/2022/1/4/232c2c5a-009e-4092-8e18-05590d92bd9c1641295756561-DressBerry-Women-Beige-Pointy-Toed-Flats-2281641295756213-1.jpg",
            "brand": "DressBerry",
            "type": "Women Pointy-Toed Flats",
            "product" : "Flat",
            "price": "809",
            "MP": "1799",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7326288/2018/10/6/37e8316c-4ca8-45e5-97ba-a78530b111e31538803609384-Street-Style-Store-Women-Black-Woven-Design-Open-Toe-Flats-9681538803609216-1.jpg",
            "brand": "Street Style Store",
            "type": "Women Open Toe Flats",
            "product" : "Flat",
            "price": "799",
            "MP": 1000,
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13308810/2021/4/1/54cee3aa-36d9-4fba-b135-a95473ae26d71617274509272-DressBerry-Women-Mustard-Yellow-Solid-Ballerinas-with-Suede--1.jpg",
            "brand": "DressBerry",
            "type": "Women Suede Finish Ballerinas",
            "product" : "Flat",
            "price": "1699",
            "MP": 2000,
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15847808/2021/10/19/c52e09d7-e67b-4483-9c72-d93669dcf6041634617556829ShezoneWomenGreyOpenToeFlatswithBows1.jpg",
            "brand": "Shezone",
            "type": "Women Open Toe Flats",
            "product" : "Flat",
            "price": "699",
            "MP": "999",
            "offer": 30
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15847834/2021/10/19/b68c57e6-d8d3-4a73-9fd5-c35fcdf7c2411634620389211ShezoneWomenCream-ColouredBallerinaswithLaserCutsFlats1.jpg",
            "brand": "Shezone",
            "type": "Women Ballerinas Flats",
            "product" : "Flat",
            "price": "699",
            "MP": "999",
            "offer": 30
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12768990/2020/11/9/7e67b1b9-4b20-4f28-89cd-41bb8639db751604902933023VishudhWomenGunmetal-TonedSolidOpenToeFlats1.jpg",
            "brand": "Vishudh",
            "type": "Women Open Toe Flats",
            "product" : "Flat",
            "price": "549",
            "MP": "999",
            "offer": 45
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2019/3/25/12d7c775-f920-4c89-81ac-f07f6c342ee41553491998560-1.jpg",
            "brand": "Shoetopia",
            "type": "Women Solid Mules",
            "product" : "Flat",
            "price": "499",
            "MP": "999",
            "offer": 50
          },
          // flat slippers (ends here)
          // face beatuy start here
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13509854/2021/4/13/28434eb8-28a1-4d70-ba28-290bb424d5231618311009851-Olay-Women-Face-Moisturisers-1601618311009637-1.jpg",
            "brand": "Olay",
            "type": "Women SPF 24 Day Cream",
            "product" : "Beauty & Eyeliner",
            "price": "499",
            "MP": null,
            "offer": null
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/57782/2020/10/10/7505b6c6-ae86-40c0-883c-78cc391cb75e1602273099106LotusHerbalsSustainableWomenNutramoistSkinRenewalDailyCream51.jpg",
            "brand": "Lotus Herbals",
            "type": "Sustainable Nutramoist Skin Renewal Cream",
            "product" : "Beauty & Eyeliner",
            "price": "364",
            "MP": "455",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/57630/2020/10/10/40f2ef8c-9a39-4ee6-ab40-ca86c8957d291602269994214LotusHerbalsSustainableNutraniteSkinRenewalNutritiveNightCre1.jpg",
            "brand": "Lotus Herbals",
            "type": "Sustainable Nutranite Skin Renewal Night Cream",
            "product" : "Beauty & Eyeliner",
            "price": "364",
            "MP": "455",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/57692/2022/1/27/491e9858-0aec-4fa7-b31b-b1221a7bd4f21643279838266LotusHerbalsSustainableSheaButterMoisturiser120g1.jpg",
            "brand": "Lotus Herbals",
            "type": "Sustainable Shea Butter Moisturiser",
            "product" : "Beauty & Eyeliner",
            "price": "258",
            "MP": "345",
            "offer": 25
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13509842/2021/8/11/19b48d54-fc72-49d8-a20b-7754778988011628659279386OlayWomenNaturalWhite7inOneNourishingNightRepairCream50g1.jpg",
            "brand": "Olay",
            "type": "Women Night Repair Cream",
            "product" : "Beauty & Eyeliner",
            "price": "292",
            "MP": "365",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11699568/2022/1/27/d711eb0a-c9bd-473f-8367-9b99c64785a41643279982185BiotiqueWomenMorningNectarFlawlessSkinCreamwithBadamSeedOil11.jpg",
            "brand": "Biotique",
            "type": "Nectar Flawless Skin Cream",
            "product" : "Beauty & Eyeliner",
            "price": "174",
            "MP": "230",
            "offer": 24
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/57694/2020/10/10/5e174bd2-95f1-4e79-8606-482e2465ee4a1602270641317LotusHerbalsSustainableWomenWhiteAlphaHydroxyOil-FreeMoistur1.jpg",
            "brand": "Lotus Herbals",
            "type": "Sustainable Alpha Hydroxy Oil-Free Moisturiser",
            "product" : "Beauty & Eyeliner",
            "price": "260",
            "MP": "325",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7197210/2021/9/29/1d7a7e49-0f54-4a40-919d-6c9e964a19e01632856574405-Ponds-Non-Oily-Light-Moisturiser-150-ml-381632856573467-1.jpg",
            "brand": "Ponds",
            "type": "Light Moisturiser 150 ml",
            "product" : "Beauty & Eyeliner",
            "price": "192",
            "MP": "219",
            "offer": 12
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/57702/2020/10/10/1d8a3452-cef3-4d10-b547-36d3b125c8a21602270806662LotusHerbalsSustainableAlmondAnti-WrinkleCreme50g1.jpg",
            "brand": "Lotus Herbals",
            "type": "Sustainable Almond Anti-Wrinkle Creme",
            "product" : "Beauty & Eyeliner",
            "price": "356",
            "MP": "475",
            "offer": 25
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13509846/2021/8/11/b67377aa-386a-41e3-b1a7-7e3889d7eb531628659416371OlayTotalEffects7InOneNightCream-50g1.jpg",
            "brand": "Olay",
            "type": "7 In One Night Cream",
            "product" : "Beauty & Eyeliner",
            "price": "719",
            "MP": "899",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9337273/2020/5/19/5fde2839-c24b-47f5-8d7d-678c6f5b8b531589882046284NiveaSetof2BodyFaceMoisturisers1.jpg",
            "brand": "Nivea",
            "type": "Lotion & Face Moisturisers",
            "product" : "Beauty & Eyeliner",
            "price": "471",
            "MP": "524",
            "offer": 10
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15506304/2021/10/5/d0d42ed8-295a-49ab-9a11-c328333f30661633428468519-Dove-Women-Face-Moisturisers-6331633428468424-1.jpg",
            "brand": "Dove",
            "type": "Body Butter Paraben Free",
            "product" : "Beauty & Eyeliner",
            "price": "218",
            "MP": "230",
            "offer": 5
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11318446/2021/8/11/7141eb69-c1c5-4e4d-8dc1-bbf15ddf0bde1628671502854OlayWomenRegeneristMicro-SculptingAnti-AgeingFaceMoisturiser1.jpg",
            "brand": "Olay",
            "type": "Regenerist Face Moisturiser",
            "product" : "Beauty & Eyeliner",
            "price": "339",
            "MP": "399",
            "offer": 15
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11752718/2020/9/29/332a6efb-6580-4947-abb1-e6aec905ea071601376847184-Lotus-Herbals-Women-Face-Moisturisers-871601376846087-1.jpg",
            "brand": "Lotus Herbals",
            "type": "Anti-Blemish Creme 50 g",
            "product" : "Beauty & Eyeliner",
            "price": "620",
            "MP": "775",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11618812/2020/10/10/581ad042-7e67-4abe-8e93-8ef02376eadb1602273112716LotusHerbalsSustainableYOUTHRXGineplexYouthActivatingSerumCr1.jpg",
            "brand": "Lotus Herbals",
            "type": "Sustainable Youth Activating Serum+Creme",
            "product" : "Beauty & Eyeliner",
            "price": "875",
            "MP": 1000,
            "offer": 11
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/55243/2022/3/21/67b62137-0277-460f-a0d2-385bdd09be941647860136423-Lakme-Perfecting-Liquid-Foundation---Natural-Pearl-27ml-5181-1.jpg",
            "brand": "Lakme",
            "type": "Natural Pearl Foundation",
            "product" : "Beauty & Eyeliner",
            "price": "130",
            "MP": "155",
            "offer": 16
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10792562/2022/3/25/17bbc36f-c331-42b0-b5ef-0de38fa40d3d1648208654463-Lakme-9To5-Primer--Matte-Perfect-Cover-Foundation---Neutral--1.jpg",
            "brand": "Lakme",
            "type": "Foundation-Neutral Medium N220",
            "product" : "Beauty & Eyeliner",
            "price": "437",
            "MP": "475",
            "offer": 8
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2018/11/24/6bb916d7-8f56-4c36-8a41-e1b9dead44e81543029083259-1.jpg",
            "brand": "VLCC",
            "type": "Facial Kit",
            "product" : "Beauty & Eyeliner",
            "price": "350",
            "MP": 500,
            "offer": 30
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1954340/2022/4/25/65d4a9b6-a9dd-4d14-b66c-293b5ba647531650873316918-Ponds-Bright-Beauty-Spot-Less-Glow-Face-Wash-with-Vitamins---1.jpg",
            "brand": "Ponds",
            "type": "Bright Beauty Face Wash 100 g",
            "product" : "Beauty & Eyeliner",
            "price": "175",
            "MP": 300,
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2018/11/24/19ee9b8e-84c9-4bff-b0f1-ae07c7235a951543028025098-1.jpg",
            "brand": "Biotique",
            "type": "BB and CC Cream",
            "product" : "Beauty & Eyeliner",
            "price": "151",
            "MP": "199",
            "offer": 24
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11629100/2022/3/30/59095c7e-fa6c-40ea-aec8-aa51d83efb621648624226950Lakme9to5WeightlessMiniMousseFoundation-RoseIvory6g1.jpg",
            "brand": "Lakme",
            "type": "9 to 5 Mousse - Rose Ivory",
            "product" : "Beauty & Eyeliner",
            "price": "148",
            "MP": "160",
            "offer": 7
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10924304/2022/4/1/ef58e645-ca88-43ee-b54f-82d7c91673f71648804709050FACESCANADAWeightlessStayMatteCompactSPF-20VitaminESheaButte1.jpg",
            "brand": "FACES CANADA",
            "type": "SPF 20 Matte Compact - Sand 04",
            "product" : "Beauty & Eyeliner",
            "price": "155",
            "MP": "199",
            "offer": 22
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/62474/2022/3/21/e3c77daa-76fe-4623-b0f6-e3d4d99cb2721647845969213-Maybelline-Lip-Smooth-Color-Changing-Peach-Bloom-Lip-Balm-17-1.jpg",
            "brand": "Maybelline",
            "type": "Peach Bloom Lip Balm 1.7g",
            "product" : "Beauty & Eyeliner",
            "price": "135",
            "MP": "180",
            "offer": 25
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/18/ee9cbe99-9a9e-49f8-b603-da69d9cc6c371621319188346-1.jpg",
            "brand": "Plum",
            "type": "Rose Water Toner 100 ml",
            "product" : "Beauty & Eyeliner",
            "price": "180",
            "MP": "225",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/55276/2022/4/1/3aad48c4-7adb-4c37-9c0d-17a703dc7c381648804698184LakmeRosePowderWithSunscreen1.jpg",
            "brand": "Lakme",
            "type": "Rose Powder With Sunscreen",
            "product" : "Beauty & Eyeliner",
            "price": "168",
            "MP": "175",
            "offer": 4
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12678954/2020/10/9/b82a6915-8d35-4510-93e8-249c2b115e541602216132908-Biotique-Advanced-Organics-Apple-Cider-Vinegar-Deep-Cleansin-1.jpg",
            "brand": "Biotique",
            "type": "Women Apple Cider Face Wash",
            "product" : "Beauty & Eyeliner",
            "price": "171",
            "MP": "225",
            "offer": 24
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11038230/2022/2/21/9bbd553c-d41e-4c23-b47e-07aaefee391b1645444471767-Livon-Set-of-2-Anti-Frizz-Hair-Serum-with-Vitamin-E--Argan-O-1.jpg",
            "brand": "Livon",
            "type": "Set of 2 Anti-Frizz Hair Serum",
            "product" : "Beauty & Eyeliner",
            "price": "415",
            "MP": "500",
            "offer": 17
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6837535/2022/3/9/0860bcb0-6525-4ac3-96be-a6b5cee3b9cf1646825666381TRESemmeKeratinSmoothShampoo580ml1.jpg",
            "brand": "TRESemme",
            "type": "Keratin Smooth Shampoo",
            "product" : "Beauty & Eyeliner",
            "price": "525",
            "MP": 600,
            "offer": 11
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10792552/2022/3/21/825670ab-7b84-4828-8357-e5eb5a45dc421647862301030-Lakme-9-To-5-Primer-And-Matte-Perfect-Cover-Foundation---Coo-1.jpg",
            "brand": "Lakme",
            "type": "Foundation - Cool Rose C140",
            "product" : "Beauty & Eyeliner",
            "price": "432",
            "MP": "475",
            "offer": 9
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8667341/2022/4/20/82ce3069-8759-4392-882d-e971a10b06481650452216826-Dove-Hair-Fall-Rescue-Shampoo-For-Weak-Hair-1-l-492165045221-1.jpg",
            "brand": "Dove",
            "type": "Hair Fall Rescue Shampoo",
            "product" : "Beauty & Eyeliner",
            "price": "849",
            "MP": 1000,
            "offer": 15
          },
          // face beaty ends here
          // dresses start here
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2018/11/24/fdb171ec-546c-4589-a904-9ed6d925793b1543044594769-1.jpg",
            "brand": "Madame",
            "type": "Women Striped Drop-Waist Dress",
            "price": "2599",
            "product" : "Dresses",
            "MP": 3000,
            "offer": 13
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/4/17fa3c4c-fa58-4446-98b2-11e96bdbf3a61620124841086-1.jpg",
            "brand": "Madame",
            "type": "Printed Midi A-Line Dress",
            "product" : "Dresses",
            "price": "1799",
            "MP": "2999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6978659/2018/8/20/92d4b826-a6fd-4a40-bfb1-e068824f10381534741660431-Madame-Women-Dresses-8091534741660228-1.jpg",
            "brand": "Madame",
            "type": "Women Printed Maxi Dress",
            "product" : "Dresses",
            "price": "2999",
            "MP": 5000,
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15201456/2021/8/19/fb84db91-2ecc-4b62-99d8-880af3ea81291629375046844MadameBeigeCheckedCrepeShirtDress1.jpg",
            "brand": "Madame",
            "type": "Checked Crepe Shirt Dress",
            "product" : "Dresses",
            "price": "1079",
            "MP": "2699",
            "offer": 60
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/17178278/2022/3/9/0af68bea-5c44-4368-a243-efd3074f0d261646828208387LoungePantsMBeautifulWomenNightsuitsMBeautifulWomenNightsuit1.jpg",
            "brand": "Madame",
            "type": "Women Solid Maxi Dress",
            "product" : "Dresses",
            "price": "3499",
            "MP": 4000,
            "offer": 18
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16121484/2021/11/17/49f42cb2-e34b-40fe-8997-f499da3705871637149830095MadameGreenDress1.jpg",
            "brand": "Madame",
            "type": "Layered Dress",
            "product" : "Dresses",
            "price": "919",
            "MP": "2299",
            "offer": 60
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/4/d11b0ab2-0e70-4ec0-a98e-6255d417f1311620125039891-1.jpg",
            "brand": "Madame",
            "type": "Printed Fit and Flare Dress",
            "product" : "Dresses",
            "price": "1799",
            "MP": "2999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11293050/2020/1/22/7e22ab09-ab9d-4641-9ddf-69d885ef69e11579687745016-Madame-Women-Sea-Green-Printed-Fit-and-Flare-Dress-726157968-1.jpg",
            "brand": "Madame",
            "type": "Printed Fit & Flare Dress",
            "product" : "Dresses",
            "price": "1559",
            "MP": "2599",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/17446510/2022/3/9/a86bc641-2047-4c6c-a5cf-b92b0fa3d4d21646822961641ZinkLondonGreenAnimalDress1.jpg",
            "brand": "Zink London",
            "type": "Floral Empire Dress",
            "product" : "Dresses",
            "price": "1839",
            "MP": "2299",
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13748770/2021/3/3/66b3d5fe-c1b7-4404-bbc2-bf366db208831614763478473-Madame-Women-Sea-Green-Solid-A-Line-Dress-3171614763477142-1.jpg",
            "brand": "Madame",
            "type": "Solid A-Line Dress",
            "product" : "Dresses",
            "price": "1379",
            "MP": "2299",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13748776/2021/3/3/9dec4613-7dba-42ed-9048-059946d47bc31614764288358-Madame-Women-Purple-Solid-A-Line-Dress-5201614764286111-1.jpg",
            "brand": "Madame",
            "type": "Solid A-Line Dress",
            "product" : "Dresses",
            "price": "1379",
            "MP": "2299",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/17178288/2022/3/9/54cbf167-9f88-4dd8-a29f-f334b9f7d2381646828159232LoungePantsMBeautifulWomenNightsuitsMBeautifulWomenNightsuit1.jpg",
            "brand": "Madame",
            "type": "Women Embroidered Maxi Dress",
            "product" : "Dresses",
            "price": "3299",
            "MP": 4000,
            "offer": 18
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15751500/2021/10/6/b05f572a-8600-4b2a-9759-6ff9b7ed1cc91633517005745MadameTurquoiseBlueDress1.jpg",
            "brand": "Madame",
            "type": "Flutter Sleeved Dress",
            "product" : "Dresses",
            "price": "919",
            "MP": "2299",
            "offer": 60
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/4/cf8c115e-24b1-45bb-9ba8-b86192a0b75d1620124837630-1.jpg",
            "brand": "Madame",
            "type": "Printed Midi A-Line Dress",
            "product" : "Dresses",
            "price": "1799",
            "MP": "2999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/17240254/2022/2/22/d15e2647-6e52-41d6-84b5-4809cf009b581645515626839CODEbyLifestyleBlueFloralDress1.jpg",
            "brand": "CODE by Lifestyle",
            "type": "Women Blue Floral Dress",
            "product" : "Dresses",
            "price": "2499",
            "MP": 3000,
            "offer": 20
          },
          // dress ends here
          // shoes start here
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11264120/2022/1/11/ed69bd6b-242b-4c1e-8f86-6579c61106bb1641886437380-DressBerry-Women-White-Solid-Sneakers-1801641886437116-1.jpg",
            "brand": "DressBerry",
            "type": "Women Solid Sneakers",
            "product" : "shoes",
            "price": "1594",
            "MP": "2899",
            "offer": 45
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13381274/2021/1/11/4fa3094c-851d-45a5-9452-1076a6b54cb41610355713577-Ginger-by-Lifestyle-Women-White-Driving-Shoes-10916103557123-1.jpg",
            "brand": "Ginger by Lifestyle",
            "type": "Women Solid Driving Shoes",
            "product" : "shoes",
            "price": "1709",
            "MP": "2999",
            "offer": 43
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8396059/2019/10/22/c0797cc9-3f91-4242-9ad4-49d5a4e78d431571734906586-Kook-N-Keech-Women-White-Sneakers-1691571734904452-1.jpg",
            "brand": "Kook N Keech",
            "type": "Women Sneakers",
            "product" : "shoes",
            "price": "869",
            "MP": "2899",
            "offer": 70
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2450219/2018/7/18/98de6ce2-0874-4c3a-841a-3ba96c4cbf721531907093943-ether-Women-Casual-Shoes-811531907093591-1.jpg",
            "brand": "ether",
            "type": "Women Sneakers",
            "product" : "shoes",
            "price": "1149",
            "MP": "2299",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/4879974/2018/7/3/c79e0284-5ede-43d2-88f0-b63efc3e52841530608539857-Kook-N-Keech-Women-Casual-Shoes-3331530608539751-1.jpg",
            "brand": "Kook N Keech",
            "type": "Women Sneakers",
            "product" : "shoes",
            "price": "1034",
            "MP": "2299",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7240622/2021/12/28/41a2286d-5fe5-4c9e-be9d-c75e56e40b921640692050659ShoetopiaWomenWhiteSneakers1.jpg",
            "brand": "Shoetopia",
            "type": "Women Sneakers",
            "product" : "shoes",
            "price": "599",
            "MP": "999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8396065/2019/10/24/2e1d2398-3e5b-45fe-bb6b-513dfb72bebc1571895106224-Kook-N-Keech-Women-White-Sneakers-7161571895104684-1.jpg",
            "brand": "Kook N Keech",
            "type": "Women Sneakers",
            "product" : "shoes",
            "price": "1449",
            "MP": "2899",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/4879970/2018/7/3/6fdbdb21-2433-4914-9f51-015f4ae493dd1530610259796-Mast--Harbour-Women-White-Sneakers-7891530610259640-1.jpg",
            "brand": "Mast & Harbour",
            "type": "Women Sneakers",
            "product" : "shoes",
            "price": "2299",
            "MP": 3000,
            "offer": 22,
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15011436/2021/10/13/f292cd15-2f0e-4661-9e74-7db076c97a881634110701671-Kook-N-Keech-Women-Casual-Shoes-3021634110701372-1.jpg",
            "brand": "Kook N Keech",
            "type": "Women Solid Sneakers",
            "product" : "shoes",
            "price": "1379",
            "MP": "2299",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2454497/2018/3/19/11521443411300-Puma-Women-White-Sneakers-8601521443411261-1.jpg",
            "brand": "Puma",
            "type": "Women Smash V2 L Sneakers",
            "product" : "shoes",
            "price": "2974",
            "MP": "3499",
            "offer": 15
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15357682/2021/11/12/97213365-cd54-4642-91d6-20f2267de3791636699708595-Mast--Harbour-Women-Casual-Shoes-5071636699708293-1.jpg",
            "brand": "Mast & Harbour",
            "type": "Women Solid Sneakers",
            "product" : "shoes",
            "price": "1149",
            "MP": "2299",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8396071/2019/5/22/b9480b19-9c01-464f-951d-6117011588ba1558517020340-Mast--Harbour-Women-Casual-Shoes-5881558517019407-1.jpg",
            "brand": "Mast & Harbour",
            "type": "Women Sneakers",
            "product" : "shoes",
            "price": "1484",
            "MP": "2699",
            "offer": 45
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11261274/2020/11/27/d1920f0e-87dc-4ae2-9483-7a2ee6d65c771606474166664HRXbyHrithikRoshanWomenWhiteAthleisureShoe1.jpg",
            "brand": "HRX by Hrithik Roshan",
            "type": "Women Woven Design Sneakers",
            "product" : "shoes",
            "price": "1599",
            "MP": "3999",
            "offer": 60
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13381270/2021/5/13/86ade4af-8122-4292-afb6-6fcf0c159a391620893603133-Ginger-by-Lifestyle-Women-White-Sneakers-1151620893602689-1.jpg",
            "brand": "Ginger by Lifestyle",
            "type": "Women Colourblocked PU Sneakers",
            "product" : "shoes",
            "price": "1499",
            "MP": "2499",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15216664/2021/8/21/2ad6947e-ea0c-4046-bae3-0fb142e43c511629533595171GingerbyLifestyleWomenWhiteColourblockedSneakers1.jpg",
            "brand": "Ginger by Lifestyle",
            "type": "Women Textured Sneakers",
            "product" : "shoes",
            "price": "1499",
            "MP": 3000,
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15911844/2021/10/24/f63d731c-76a7-4e96-8a1e-b1482a11187f1635058247466PeopleWomenBlackTaperedFitSlashKneeJeans1.jpg",
            "brand": "People",
            "type": "Women Tapered Fit Jeans",
            "product" : "shoes",
            "price": "1299",
            "MP": 2600,
            "offer": 50
          },
           // dress ends here
           // sports-outfit
           {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8475743/2019/4/4/e33218ab-48be-441e-a9b7-e0ae157ceed71554375840623-HRX-by-Hrithik-Roshan-Charcoal-Solid-Non-Wired-Lightly-Padde-1.jpg",
            "brand": "HRX",
            "type": "Seamless Padded Sports Bra",
            "product" : "sports-outfit",
            "price": "389",
            "MP": "1299",
            "offer": 70
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8475737/2019/4/4/9893a421-b3e3-4612-b3ab-87d90f7c67cc1554375827892-HRX-by-Hrithik-Roshan-Green-Self-Design-Non-Wired-Lightly-Pa-1.jpg",
            "brand": "HRX",
            "type": "Seamless Padded Sports Bra",
            "product" : "sports-outfit",
            "price": "844",
            "MP": "1299",
            "offer": 35
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8475771/2022/4/11/ea86f5c0-17f9-4636-8276-dc737cd5fabc1649655561090-HRX-by-Hrithik-Roshan-Seamless-Green-Lightly-Padded-Rapid-dr-1.jpg",
            "brand": "HRX",
            "type": "Bra",
            "product" : "sports-outfit",
            "price": "584",
            "MP": "1299",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8475759/2022/3/22/f9167cda-316f-4966-b8b9-eee716107fbf1647944596697-HRX-by-Hrithik-Roshan-Seamless-Women-Coral-Orange-Rapid-Dry--1.jpg",
            "brand": "HRX",
            "type": "Seamless Rapid Dry Yoga Bra",
            "product" : "sports-outfit",
            "price": "439",
            "MP": "1099",
            "offer": 60
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9050703/2019/5/29/7b53bebc-4ff1-435b-b60c-7c01531e20761559119481394-DressBerry-Grey-Melange-Solid-Non-Wired-Heavily-Padded-T-shi-1.jpg",
            "brand": "DressBerry",
            "type": "Lightly Padded T-shirt Bra",
            "product" : "sports-outfit",
            "price": "314",
            "MP": "899",
            "offer": 65
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8475711/2019/3/13/310c8cb5-595d-4bb9-817a-5cb6af155dfe1552458918414-HRX-by-Hrithik-Roshan-Grey-Printed-Lightly-Padded-RAPID-DRY--1.jpg",
            "brand": "HRX",
            "type": "Seamless RAPID-DRY Sports Bra",
            "product" : "sports-outfit",
            "price": "594",
            "MP": "1699",
            "offer": 65
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11862234/2020/7/29/b58ac067-2a85-4b65-b419-a27a8f7fd78d1596001811098HERENOWMenWhiteRedStripedRoundNeckT-shirtBraHRXbyHrithikRosh1.jpg",
            "brand": "HRX",
            "type": "Running Rapid-Dry Sports Bra",
            "product" : "sports-outfit",
            "price": "764",
            "MP": "1699",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13983656/2021/6/29/2b8ba030-124b-417e-a0ac-49b8ec3774331624964672458-DressBerry-Women-Bra-2021624964671953-1.jpg",
            "brand": "DressBerry",
            "type": "Workout Bra",
            "product" : "sports-outfit",
            "price": "164",
            "MP": "549",
            "offer": 70
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13983648/2021/6/29/281e694a-7d20-46ac-85e3-66326f6899341624962437304-DressBerry-Women-Bra-6551624962436761-1.jpg",
            "brand": "DressBerry",
            "type": "Workout Bra",
            "product" : "sports-outfit",
            "price": "192",
            "MP": "549",
            "offer": 65
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14701460/2021/9/10/98e495f7-2818-44b4-bb2a-027b86a20f6e1631246415969-HRX-by-Hrithik-Roshan-Women-Bra-5901631246415216-1.jpg",
            "brand": "HRX",
            "type": "Training Rapid-Dry Sports Bra",
            "product" : "sports-outfit",
            "price": "524",
            "MP": "1499",
            "offer": 65
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9320545/2019/4/15/c21a7844-357b-4a95-a528-032f949d75891555325250808-Zivame-Padded-Wirefree-Bra--Red-6971555325250400-1.jpg",
            "brand": "Zivame",
            "type": "Lightly Padded T-shirt Bra",
            "product" : "sports-outfit",
            "price": "411",
            "MP": "749",
            "offer": 45
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9050707/2019/5/29/54335ee9-f35e-4b8e-bdc7-9292db2b77dc1559119492474-DressBerry-Women-Bra-611559119491866-1.jpg",
            "brand": "DressBerry",
            "type": "Lightly Padded T-shirt Bra",
            "product" : "sports-outfit",
            "price": "269",
            "MP": "899",
            "offer": 70
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15115018/2021/8/19/5a50fe5c-2b0a-49fe-a37a-35d9b566a4401629354590350JockeyLightGreyMelangeSlipOnActiveBra13761.jpg",
            "brand": "Jockey",
            "type": "Slip-On Sports Bra",
            "product" : "sports-outfit",
            "price": "579",
            "MP": 1000,
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2306777/2017/12/4/11512394342021-Zivame-Padded-Wirefree-T-shirt-Bra--Black-2411512394341892-1.jpg",
            "brand": "Zivame",
            "type": "Lightly Padded T-shirt Bra",
            "product" : "sports-outfit",
            "price": "449",
            "MP": "899",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13370868/2021/2/15/92a6f744-20f6-4120-8eef-5faa0c42cdd81613393848462-Enamor-Pink-Solid-Non-Wired-Non-Padded-Everyday-Bra-19916133-1.jpg",
            "brand": "Enamor",
            "type": "Non Padded Everyday Bra",
            "product" : "sports-outfit",
            "price": "449",
            "MP": 1000,
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11357430/2020/2/26/5a8ae7d2-b098-48dc-b69a-19f113c915f11582693069169-HRX-by-Hrithik-Roshan-Women-Shorts-8891582693066899-1.jpg",
            "brand": "HRX",
            "type": "Women Running Rapid-Dry Shorts",
            "product" : "sports-outfit",
            "price": "674",
            "MP": "1499",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/1/21/4d2ed754-05e1-4ee7-8a2d-d6b3677b70a11611228971382-1.jpg",
            "brand": "Clovia",
            "type": "Women Solid Ankle Length Training Tights",
            "product" : "sports-outfit",
            "price": "584",
            "MP": "1299",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12959222/2022/4/20/6983e9a3-cea0-41d0-93b8-0d6980fd3a9f1650451192884DomyosbyDecathlonWomenBlackHighWaistSkin-TightFitnessShorts1.jpg",
            "brand": "Domyos By Decathlon",
            "type": "Women Cardio Training Shorts",
            "product" : "sports-outfit",
            "price": "854",
            "MP": "899",
            "offer": 5
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10106535/2019/9/19/9952e7ac-4522-4cfe-abd1-7b591250bb291568891066162-HRX-by-Hrithik-Roshan-Women-Red-Rapid-Dry-Yoga-Seamless-Shor-1.jpg",
            "brand": "HRX",
            "type": "Women Yoga Seamless Shorts",
            "product" : "sports-outfit",
            "price": "449",
            "MP": "1499",
            "offer": 70
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/2/22/87a1ed11-990e-4c07-8bd8-e65700e0306b1614002659146-1.jpg",
            "brand": "Clovia",
            "type": "Activewear Sports Tights",
            "product" : "sports-outfit",
            "price": "610",
            "MP": "1299",
            "offer": 53
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/12/5/8f763367-e2d1-4440-8cd7-4b1216947c341607174318712-1.jpg",
            "brand": "Domyos By Decathlon",
            "type": "Occasional Fitness Tank Top",
            "product" : "sports-outfit",
            "price": "474",
            "MP": "499",
            "offer": 5
          },
          
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/4/c8ba10f6-6594-4426-b65d-72f55f2153341620105764568-2.jpg",
            "brand": "Domyos By Decathlon",
            "type": "Women Solid Ankle-Length Organic Cotton Yoga Leggings",
            "product" : "sports-outfit",
            "price": "699",
            "MP": 1000,
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10106163/2019/9/3/1e55c9f0-0be0-4b9f-a6aa-331c984086cc1567511778666-HRX-by-Hrithik-Roshan-Women-Tights-8471567511775688-4.jpg",
            "brand": "HRX",
            "type": "Women Seamless Yoga Tights",
            "product" : "sports-outfit",
            "price": "1499",
            "MP": 3000,
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7688006/2021/7/27/e0f77cd9-cffc-4049-9911-08e815a7a54a1627371128568-HRX-by-Hrithik-Roshan-Women-Navy-Blue-Solid-Rapid-Dry-Runnin-1.jpg",
            "brand": "HRX",
            "type": "Women Running T-shirt",
            "product" : "sports-outfit",
            "price": "349",
            "MP": "999",
            "offer": 65
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/4/16/bf8ddd19-38ab-4aa2-89e7-2716817b26111618578647471-1.jpg",
            "brand": "Domyos By Decathlon",
            "type": "Women Skinny Fit Sports Shorts",
            "product" : "sports-outfit",
            "price": "499",
            "MP": 1000,
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8328163/2019/4/2/9ca4fde8-35b1-4b88-b9b9-a6c326d51df31554201033546-HRX-by-Hrithik-Roshan-Women-Black-Solid-Regular-Fit-Sports-S-4.jpg",
            "brand": "HRX",
            "type": "Women Rapid dry Sports Shorts",
            "product" : "sports-outfit",
            "price": "1499",
            "MP": 1000,
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13549216/2021/3/15/b76c73b6-9135-4997-a444-31b19b5fe8c01615804088995ChkokkoWomenBlackSolidRunningShorts1.jpg",
            "brand": "Chkokko",
            "type": "Women Running Shorts",
            "product" : "sports-outfit",
            "price": "699",
            "MP": "2330",
            "offer": 70
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/3/31/d55d48fc-f135-4a27-af54-d5fd267bdbad1617177260742-1.jpg",
            "brand": "Zelocity by Zivame",
            "type": "Women Solid Tights",
            "product" : "sports-outfit",
            "price": "597",
            "MP": "1195",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10565506/2020/2/4/900c17fc-9cca-45b3-93dd-493d66d0e2531580805529814-HRX-by-Hrithik-Roshan-Women-Black-Printed-Back-Running-Tank--1.jpg",
            "brand": "HRX",
            "type": "Running Rapid-Dry Tank Top",
            "product" : "sports-outfit",
            "price": "359",
            "MP": "899",
            "offer": 60
          }, 
  ]

  export default WomenData;